import { render, staticRenderFns } from "./quotaRecords.vue?vue&type=template&id=e23a6330&scoped=true"
import script from "./quotaRecords.vue?vue&type=script&lang=jsx"
export * from "./quotaRecords.vue?vue&type=script&lang=jsx"
import style0 from "./quotaRecords.vue?vue&type=style&index=0&id=e23a6330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23a6330",
  null
  
)

export default component.exports